import { NanQ, ToNumber } from "@pdfking/math"
import { Identity } from "@pdfking/tfunc"

import type { ImpositionSchema } from "#internal"
import type { SortFunction } from "#internal"

import { MakeOnTopSortingFunction } from "./MakeOnTopSortingFunction"

export const ResolveSortFunction = (input: ImpositionSchema): SortFunction => {
  const on_top = input.on_top.id
  if (on_top === "off") return Identity
  if (on_top === "on") return MakeOnTopSortingFunction()
  const limit = ToNumber(on_top.slice(1))
  if (!NanQ(limit)) return MakeOnTopSortingFunction(limit)
  return MakeOnTopSortingFunction()
}
